import SelectComponent from '@componentes/select/select.component';
import React from 'react';
import { Row, Col, FormGroup, Label, Input, Card, CardBody, CardTitle, CardText } from 'reactstrap';

const CestaPage = (props) => (
    <div>
        <Row>
            <Col>
                <FormGroup>
                    <Label>Centro de responsabilidades:</Label>
                    <SelectComponent options={props.centroDeResponsabilidades} placeholder="Selecionar centro de responsabilidade"
                        onChange={(e) => { props.onChangeCentroDeResponsabilidade(e.label) }} />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col>
                <FormGroup>
                    <Label>Cesta:</Label>
                    <SelectComponent options={props.cestas} placeholder="Selecionar cesta"
                        onChange={(e) => { props.onChangeCesta(e.label) }} />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col>
                <FormGroup check>
                    <Label check>
                        <Input type="checkbox" />{' '}
                        Todos os blocos
                    </Label>
                </FormGroup>
            </Col>
            {
                props.blocos.map(bloco => {
                    return (
                        <Col key={bloco.id}>
                            <FormGroup check>
                                <Label check onClick={() => { props.onClickCheckboxBloco(bloco.bloco, bloco.numero) }}>
                                    <Input type="checkbox" />{' '}
                                    {`${bloco.bloco} - ${bloco.numero} ${bloco.material} ${bloco.tipo}`}
                                </Label>
                            </FormGroup>
                        </Col>
                    )
                })
            }
        </Row>
        <br />
        {
            props.blocoNaCesta.map(blocoCesta => {
                return (
                    <Row>
                        <Col>
                            <Card>
                                <CardBody>
                                    <CardTitle>{blocoCesta.bloco}</CardTitle>
                                    <CardText>{blocoCesta.centroResponsabilidade}</CardText>
                                    <CardText>{`${blocoCesta.numero}, cesta ${blocoCesta.cesta}`}</CardText>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )
            })
        }
    </div>
)

export default CestaPage;


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/operacoes/cesta/cesta.page.js